import { takeLatest, call } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import { httpResponseCheckSaga } from 'src/store/commonSaga';
import { apiChangeOrganization } from 'src/api/sidebar';
import { commonSlice } from 'src/store/commonPart/slice';
import { hardRedirect } from 'src/utils/hardRedirect';

function* changeOrganizationSaga({ payload }: PayloadAction<string>): Generator {
  yield httpResponseCheckSaga(
    function* () {
      return yield call(apiChangeOrganization, payload);
    },
    hardRedirect,
    commonSlice.actions.changeOrganizationError
  );
}

export function* sidebarSagas(): Generator {
  yield takeLatest(commonSlice.actions.changeOrganizationStart.type, changeOrganizationSaga);
}
